import React, { useCallback, useState, memo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import qs from "qs";
import { TocItem } from "discover.medical.react-component-library";
import { SEARCH_PATH_PREFIX } from "../../../config";

export const ANIMATION_DURATION = 250;

const HierarchyNode = ({
  content,
  label,
  level,
  isLink,
  path,
  hasChildren,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const history = useHistory();
  const hierarchyNodeId = encodeURIComponent(
    path.split("|").splice(2).join("|")
  );

  const handleNodeClick = () => {
    if (isOpened) {
      // Closing node, let's remove the last component of the ID
      const newPathParts = decodeURIComponent(hierarchyNodeId)
        .split("|")
        .slice(0, -1);
      const newUrl = newPathParts.length
        ? `?path=${encodeURIComponent(newPathParts.join("|"))}`
        : { location: { ...history.location, search: undefined } };
      history.push(newUrl);
    } else {
      // Opening node
      history.push(`?path=${hierarchyNodeId}`);
    }

    setIsOpened(!isOpened);
  };

  const handleLeafClick = useCallback(() => {
    history.push(SEARCH_PATH_PREFIX + encodeURI(path));
  }, [history, path]);

  useEffect(() => {
    const { path: urlPath } = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    });
    if (encodeURIComponent(urlPath).includes(hierarchyNodeId)) {
      // If path query param contains this Hierarchy Node's ID (child node or parent), set open
      setIsOpened(true);
    }
  }, [hierarchyNodeId, history.location.search]);

  return (
    <TocItem
      id={hierarchyNodeId}
      color={isLink ? "anchor" : "gray800"}
      title={label}
      fontSize="md"
      onClick={hasChildren ? handleNodeClick : handleLeafClick}
      isExpanded={isOpened}
    >
      {hasChildren &&
        content.map((node) => (
          <HierarchyNode
            {...node}
            level={level + 1}
            path={`${path}|${node.label}`}
            key={node.label}
            isLink={true}
          />
        ))}
    </TocItem>
  );
};

HierarchyNode.propTypes = {
  label: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  content: PropTypes.array,
  path: PropTypes.string.isRequired,
  hasChildren: PropTypes.bool.isRequired,
};

HierarchyNode.defaultProps = {
  content: [],
};

export default memo(HierarchyNode);
